import AuthResetPasswordForm from '../../components/reset-password/reset-password';
import useResetPassword from './hooks/use-reset-password';

const ResetPassword = () => {
  const {
    control,
    onSubmit,
    errors,
    passwordValue,
    passwordIsValid,
    onValidatePassword,
    passwordValidation,
    isLoading,
    globalError,
  } = useResetPassword();

  return (
    <AuthResetPasswordForm
      control={control}
      onSubmit={onSubmit}
      errors={errors}
      passwordValue={passwordValue}
      passwordIsValid={passwordIsValid}
      onValidatePassword={onValidatePassword}
      passwordValidation={passwordValidation}
      requestInProgress={isLoading}
      globalError={globalError}
    />
  );
};

export default ResetPassword;
